/* import __COLOCATED_TEMPLATE__ from './node-type.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();